var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 8.0001C1.3335 7.77918 1.51258 7.6001 1.7335 7.6001L14.2668 7.6001C14.4877 7.6001 14.6668 7.77918 14.6668 8.0001C14.6668 8.22101 14.4877 8.4001 14.2668 8.4001H1.7335C1.51258 8.4001 1.3335 8.22101 1.3335 8.0001Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.c9c5d8d534be69b55df42ce085fa881d.svg";
export { ForwardRef as ReactComponent };